<template>
  <div>
    <div class="header-head">
      <div
        class="header_icon animated fadeInLeft"
        style="cursor: pointer"
        @click="home()"
      >
        <div class="header-title"></div>
        <p>德财软件</p>
      </div>
      <div class="header_text animated fadeInDown">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1" @click="navigateTo('main')">首页</el-menu-item>
          <el-menu-item index="2" @click="navigateTo('Tyd')">美容美发</el-menu-item>
          <!-- <el-menu-item index="3">了解更多</el-menu-item> -->
          <!-- <el-submenu index="3">
            <template slot="title">了解更多</template>
            <el-menu-item index="31" @click="navigateTo('/Tyd')">美容美发</el-menu-item>
            <el-menu-item index="32" @click="navigateTo('/Message')">
              短信平台
            </el-menu-item>
            <el-menu-item index="33" @click="navigateTo('/Gatherwealth')">
              聚支付平台
            </el-menu-item>
            <el-menu-item index="34" @click="navigateTo('/Smartrent')">
              智能物业
            </el-menu-item>
          </el-submenu> -->
          <el-menu-item index="4" @click="navigateTo('Smartrent')">智慧物业</el-menu-item>
          <el-menu-item index="6" @click="navigateTo('Gatherwealth')">
            聚支付平台
          </el-menu-item>
          <el-menu-item index="7" @click="navigateTo('Message')">短信平台</el-menu-item>
          <el-menu-item index="8" @click="navigateTo('Marketing')">营销平台</el-menu-item>
          <!-- <el-submenu index="5">
            <template slot="title">服务查询</template>
            <el-menu-item index="51">查看审核结果</el-menu-item>
            <el-menu-item index="52">查看门店注册信息</el-menu-item>
          </el-submenu> -->
          <el-menu-item index="99">联系我们</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import baseStore from "./baseStore/baseStore.vue";

import but from "./but.js";
export default {
  components: {
    baseStore,
  },
  data() {
    return {
      activeIndex: null,
      dialogVisible: false,
      route: "",
    };
  },
  created() {},
  mounted() {
    this.route = sessionStorage.getItem("route");
    this.updateActiveIndex();
  },
  methods: {
    dialogs: function (dialog) {
      this.dialogVisible = dialog;
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      if (key == 99) {
        but.$emit("key", key);
      }
    },
    navigateTo(path) {
      this.$router.push(path);
      sessionStorage.setItem("route", path);
      this.updateActiveIndex();
    },
    // 跳转首页
    home() {
      this.$router.push("/main");
      sessionStorage.setItem("route", "main");
      this.updateActiveIndex();
    },
    updateActiveIndex() {
      switch (this.route) {
        case "main":
          this.activeIndex = "1";
          break;
        case "Tyd":
          this.activeIndex = "2";
          break;
        case "Smartrent":
          this.activeIndex = "4";
          break;
        case "Gatherwealth":
          this.activeIndex = "6";
          break;
        case "Message":
          this.activeIndex = "7";
          break;
        case "Marketing":
          this.activeIndex = "8";
          break;
        // case "contact":
        //   this.activeIndex = "99";
        //   break;
        default:
          this.activeIndex = "1";
      }
    },
  },
  watch: {
    $route(to) {
      this.route = to.name;
      sessionStorage.setItem("route", this.route);
      this.updateActiveIndex();
    },
  },
};
</script>

<style>
.header-head {
  display: flex;
  justify-content: space-between;
}

.header_icon {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 10px;
}

.header-title {
  width: 55px;
  height: 55px;
  margin-left: 100px;
  background-image: url(../../assets/title.png);
  background-repeat: no-repeat;
  background-size: 100%;
  display: inline-block;
}

.header_icon p {
  font-size: 28px;
  font-family: "楷体";
  color: white;
}

.header_icon img {
  width: 120px;
  height: 100px;
  background: #ff7788;
}

.el-menu--horizontal > .el-menu-item.is-active {
  color: white !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: none !important;
  color: rgb(216, 216, 216);
}

.header_text {
  height: 100px;
}

.el-menu-item,
.el-submenu__title {
  font-size: 18px !important;
  font-weight: 500;
  background: none;
}

.el-menu {
  margin-right: 150px;
  margin-top: 5px;
  background: none;
  font-family: "宋体";
}

.el-menu--horizontal > .el-menu-item {
  color: white;
}

.el-menu--horizontal > .el-submenu .el-submenu__title,
.el-submenu__title,
.el-submenu__title i {
  color: white !important;
}

.el-submenu__title:hover {
  background: #ff8888 !important;
  border: none;
}

.el-menu-item:hover,
.el-menu-item > li:hover {
  /* background: none !important; */
  border-bottom: #ff7788 1px solid;
}

.el-menu.el-menu--horizontal {
  border: none;
}

.el-menu--horizontal > .el-menu-item.is-active {
  /* border-bottom: 2px solid #ff7788; */
  border-bottom: 2px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue